import { NodeViewProps } from '@tiptap/react';

import {
  EmailBaseExtension,
  attributes,
  tag,
  getPlaceholderHtml,
} from '@components/email-field/extensions';
import { PlaceholderContainer, createPlaceholderNode } from '@components/text-editors/helpers';
import { useScopedTranslate } from '@locale/translate';
import { validateEmail } from '@utils/validators';

const PREBOARDING_EMAIL_EXTENSION_NAME = 'user_preboarding_email';

const NodeComponent = (props: NodeViewProps, emails: string[]) => {
  const { t } = useScopedTranslate(locale);

  const email = props.node.attrs?.value;
  const isValidEmail = validateEmail(email);
  const isEmailAlreadyUsed = emails.includes(email);

  const variant = !isValidEmail || isEmailAlreadyUsed ? 'error' : 'fixed';
  const tooltip = !isValidEmail
    ? t('invalidEmail')
    : isEmailAlreadyUsed
    ? t('emailAlreadyExists')
    : '';

  return <PlaceholderContainer tooltip={tooltip} variant={variant} {...props} />;
};

const PreboardingEmailNode = (emails: string[]) => {
  return createPlaceholderNode({
    attributes,
    renderText: getPlaceholderHtml,
    tag,
    nodeComponent: (props) => NodeComponent(props, emails),
  });
};

export const PreboardingEmail = EmailBaseExtension.extend({
  name: PREBOARDING_EMAIL_EXTENSION_NAME,
  addOptions: () => ({ single: false, emails: [] as string[] }),
  addExtensions() {
    return [PreboardingEmailNode(this.options.emails)];
  },
});

const locale = {
  en: {
    emailAlreadyExists: 'This email belongs to an existing user',
    invalidEmail: 'Invalid email address',
  },
};
